import bounceAttnGrabberImage from "./presetImages/bounce-attn-grabber.png";
import flashImage from "./presetImages/flash.png";
import pulseImage from "./presetImages/pulse.png";
import stretchImage from "./presetImages/stretch.png";
import shakeImage from "./presetImages/shake.png";
import tadaImage from "./presetImages/tada.png";
import wobbleImage from "./presetImages/wobble.png";
import heartbeatImage from "./presetImages/heartbeat.png";
import backImage from "./presetImages/back.png";
import bounceTransitionalImage from "./presetImages/bounce-transitional.png";
import fadeImage from "./presetImages/fade.png";
import flipImage from "./presetImages/flip.png";
import rotateImage from "./presetImages/rotate.png";
import zoomImage from "./presetImages/zoom.png";
import slideImage from "./presetImages/slide.png";
import typeInImage from "./presetImages/typeIn.png";
import riseImage from "./presetImages/rise.png";
import noneImage from "./presetImages/none.png";

// Typewriter preset - only shown for letter animations
export const typewriterPreset = {
  name: "typeIn",
  label: "Type In",
  image: typeInImage
};

const baseAnimationPresets = [
  { name: "none", label: "None", image: noneImage },
  { name: "slide", label: "Slide", image: slideImage },
  { name: "rise", label: "Rise", image: riseImage },
  { name: "fade", label: "Fade", image: fadeImage },
  { name: "bounce", label: "Bounce", image: bounceTransitionalImage },
  { name: "zoom", label: "Zoom", image: zoomImage },
  { name: "back", label: "Back", image: backImage },
  { name: "rotate", label: "Rotate", image: rotateImage },
  { name: "flip", label: "Flip", image: flipImage },
  { name: "boing", label: "Boing", image: bounceAttnGrabberImage },
  { name: "shake", label: "Shake", image: shakeImage },
  { name: "flash", label: "Flash", image: flashImage },
  { name: "pulse", label: "Pulse", image: pulseImage },
  { name: "rubberBand", label: "stretch", image: stretchImage },
  { name: "tada", label: "Tada", image: tadaImage },
  { name: "wobble", label: "Wobble", image: wobbleImage },
  { name: "heartBeat", label: "Heartbeat", image: heartbeatImage }
];

export const animationPresets = baseAnimationPresets;

export const transitionPresets = [
  "bounce",
  "back",
  "fade",
  "flip",
  "rotate",
  "zoom",
  "slide",
  "rise",
  "shake"
];

export const mandatoryDirectionPresets = [
  "back",
  "slide",
  "rise",
  "flip",
  "shake",
  "fade",
  "bounce",
  "zoom"
];

export const axisDirectionPresets = ["flip", "shake"];

// Presets that support "center" direction
export const centerDirectionPresets = ["fade", "bounce", "zoom"];

// Presets that support random direction (must have both "up" AND "down" directions)
// Random direction uses only up/down for visual aesthetics
export const randomDirectionPresets = [
  "slide",
  "rise",
  "fade",
  "bounce",
  "zoom",
  "back"
];

// Random direction pool - only up/down for visual consistency
export const RANDOM_DIRECTION_POOL = ["up", "down"];

// mutiple css animation presets - these can be used for start and end animations
export const multipleTransitionPresets = [
  "bounce",
  "back",
  "fade",
  "flip",
  "rotate",
  "zoom",
  "slide",
  "rise",
  "typeIn"
];

// single css animation presets - these can be used for the middle animation
export const singleTransitionPresets = [
  "shake",
  "flash",
  "pulse",
  "rubberBand",
  "tada",
  "wobble",
  "heartBeat"
];
